import qs from "qs";

export const ROOT = "/";
export const LOGIN = "/login";
export const HOME = "/home";
export const LOGOUT = "/logout";

export const GAMES = '/games';
export const GAME = `${GAMES}/:gameID`;

export const INBOX = `${GAME}/inbox`;
export const MESSAGE = `${INBOX}/:messageID`;

export const DOCUMENTS = `${GAME}/documents`;
export const PDF = `${GAME}/pdf/:pdfID`;
export const RESULTS = `${GAME}/results`;
export const BUSINESSPLAN = `${GAME}/business-plan/:businessPlanID`;

export const RESULTSDOCUMENT = `${RESULTS}/results-document`;
export const SALES = `${BUSINESSPLAN}/sales`;

export const PRODUCTION = `${BUSINESSPLAN}/production`;
export const PROCUREMENT = `${BUSINESSPLAN}/procurement`;
export const INCOMESTATEMENT = `${BUSINESSPLAN}/income-statement`;
export const BALANCESHEET = `${BUSINESSPLAN}/balance-sheet`;
export const CASHFLOW = `${BUSINESSPLAN}/cash-flow`;
export const EXPORTREPORTS = `${BUSINESSPLAN}/export-reports`;
export const SUBMISSIONPOPUP = `${BUSINESSPLAN}/submission-pop-up`;
export const SALESTEST = `${SALES}/sales-test`;
export const SALESPROGRAM = `${SALES}/sales-program`;
export const PRODUCTIONPROGRAM = `${PRODUCTION}/production-program`;
export const PRODUCTIONINTERNALLY = `${PRODUCTION}/production-internally`;
export const PRODUCTIONEXTERNALLY = `${PRODUCTION}/production-externally`;
export const PRODUCTIONQUALITYCHECK = `${PRODUCTION}/production-quality-check`;
export const PRODUCTIONFIXEDCOSTS = `${PRODUCTION}/production-fixed-costs`;
export const PROCUREMENTOVERVIEW = `${PROCUREMENT}/procurement-overview`;
export const PROCUREMENTSUPPLIER = `${PROCUREMENT}/procurement-supplier`;
export const PROCUREMENTINVENTORY = `${PROCUREMENT}/procurement-inventory`;
export const PROCUREMENTCOST = `${PROCUREMENT}/procurement-costs`;

export const ADMIN_OLD = '/admin/dfmer3224';
export const SESSIONS_OLD = `${ADMIN_OLD}/sessions`;
export const SESSION_OLD = `${SESSIONS_OLD}/:sessionID`;
export const ADMIN = '/admin';
export const ADMIN_SESSIONS = `${ADMIN}/sessions`;
export const ADMIN_SESSION = `${ADMIN_SESSIONS}/:sessionID`;
export const ADMIN_GAMES = `${ADMIN}/games`;
export const ADMIN_USERS = `${ADMIN}/users`;
export const ADMIN_USER = `${ADMIN_USERS}/:userID`;

export const apiUrl = (route, params) =>
  params
    ? `${window._env_.API_BASE_URL}${route}?${qs.stringify(params)}`
    : `${window._env_.API_BASE_URL}${route}`;
